import SearchIcon from '@atlaskit/icon/core/search';
import { Box, xcss } from '@atlaskit/primitives';
import Textfield from '@atlaskit/textfield';
import React, { type FunctionComponent, useCallback } from 'react';

const searchInputContainerStyles = xcss({
  width: '100%',
});

const searchIconWrapperStyles = xcss({
  display: 'inline-flex',
  paddingInlineStart: 'space.100',
});

export const AddFieldMenuSearchInput: FunctionComponent<{
  ariaLabel: string;
  onChange: (value: string) => void;
  placeholder: string;
  testId: string;
  value: string;
}> = ({ ariaLabel, onChange, placeholder, testId, value }) => {
  const handleChange = useCallback(
    (event: React.FormEvent) => {
      onChange((event.target as HTMLInputElement).value);
    },
    [onChange]
  );

  return (
    <Box xcss={searchInputContainerStyles}>
      <Textfield
        testId={testId}
        elemBeforeInput={
          <Box xcss={searchIconWrapperStyles}>
            <SearchIcon label="" LEGACY_size="small" />
          </Box>
        }
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        aria-label={ariaLabel}
        autoComplete="off"
        isCompact
      />
    </Box>
  );
};
